import React from "react";
import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";

import Dashboard from "./Page/Home";
import Login from "./Page/Login";
import Url from "./Page/Url";
import UncategorizedGrouped from "./Page/UncategorizedGrouped";
import SetCategory from "./Page/setCategory";

// --------------------- Protected Route ---------------------
const ProtectedRoute = ({ children }) => {
  const isAuthenticated = sessionStorage.getItem("isLoggedIn");
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Default route → Login */}
        <Route path="/" element={<Navigate to="/login" replace />} />

        {/* Login Page */}
        <Route path="/login" element={<Login />} />

        {/* Protected Pages */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/url"
          element={
            <ProtectedRoute>
              <Url />
            </ProtectedRoute>
          }
        />
        <Route
          path="/UncategorizedGrouped"
          element={
            <ProtectedRoute>
              <UncategorizedGrouped />
            </ProtectedRoute>
          }
        />
        <Route
          path="/SetCategory"
          element={
            <ProtectedRoute>
              <SetCategory />
            </ProtectedRoute>
          }
        />

        {/* Catch-all → redirect to login */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
